import themable from '_uikit/_themable'

export const Default = themable('CompanyDefaultTile')

export default { Default }
